// extracted by css-extract-rspack-plugin
export default {"item":"Ztprm","label":"KBytp","highlighted":"M5VIl","column":"cb9xh"};